import { ContainerStyles } from '../../lib/types/Style';

const container: ContainerStyles = {
  maxWidth: 87.5,
};

export default container;
